import Repository from "../Repository";

const resource = "/surveys";
export default {
    getAll(){
        return Repository.get(`${resource}`);
    },

    getOne(id) {
        return Repository.get(`${resource}/${id}`);
    },

    getSurveyReport(id) {
        return Repository.get(`${resource}/${id}/report`);
    },

    createSurvey(json){
        return Repository.post(`${resource}`,json);
    },

    updateSurvey(surveyId, json) {
        return Repository.put(`${resource}/${surveyId}`, json);
    },

    deleteSurvey(id) {
        return Repository.delete(`${resource}/${id}`);
    },

    render(id) {
        return Repository.get(`${resource}/${id}/render`);
    },


    triggerDownload(id) {
        return Repository.get(`${resource}/${id}/download`);
    },

    downloadStatus(id) {
        return Repository.get(`dlqueue/${id}`);
    },

    download(id) {
        return Repository.get(`/dlqueue/${id}/download`, {responseType: 'blob'});
    }
}